<template>
  <table-view ref="table" class="h-full"
    v-model="selected"
    :value-key="PayloadSingleId"
    :get-params-path="getParamsPathAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :filter-panel="FilterPanel"
    :route-name="routeName"
    :excel-name="excelName"
    :id-vista="idVista"
    :header-title="headerTitle"
    :header-icon="headerIcon"
    :vuexnamespace="vuexnamespace"
    :lista-acciones="listaAccionesFinal"
    :footer-acciones="footerAcciones"
    :nameSelectActions="$t('app.import')"
    actionsWithSelect
    @executeAction="executeAction"
    @headerselectionchange="onSelectionChange"
    @selectionchange="onSelectionChange">
    <template slot="dialogs">

      <import-cert-dialog
        :dialogOpen="showModalImportCert" 
        @toggleDialog="toggleImportCert" 
        @applyDialog="applyImportCert"
        :header="$t('imports.import_certs_pfx_header')" 
        :headerValue="$t('imports.pass_cert')" 
        :switchHeaderValue="$t('imports.type_import')" 
        :switchHeaderValueActive="$t('imports.type_import_certs_companies')"
        :switchHeaderValueInactive="$t('imports.type_import_only_certs')"
        />
      <import-generic-dialog
        :dialogOpen="showModalImportUser"
        @toggleDialog="toggleImportUser"
        @applyDialog="applyImportUser"
        @downloadTemplate="downloadTemplateUser"
        :header="$t('imports.import_users_header')" 
        />
      <import-generic-dialog
        :dialogOpen="showModalImportProductos"
        @toggleDialog="toggleImportProductos"
        @applyDialog="applyImportProductos"
        @downloadTemplate="downloadTemplateProductos"
        :header="$t('imports.import_productos_header')" 
        />
      <import-generic-dialog
        :dialogOpen="showModalImportSociedades"
        @toggleDialog="toggleImportSociedades"
        @applyDialog="applyImportSociedades"
        @downloadTemplate="downloadTemplateSociedades"
        :header="$t('imports.import_sociedades_header')" 
        />
      <import-generic-dialog
        :dialogOpen="showModalImportCertsSerial"
        @toggleDialog="toggleImportCertsSerial"
        @applyDialog="applyImportCertsSerial"
        @downloadTemplate="downloadTemplateCertsSerial"
        :header="$t('imports.import_certs_serial_header')" 
        />
      <import-generic-dialog
        :mandatoryClient="true"
        :activateSwitch1="true"
        :labelSwitch1="$t('imports.excel_import_options_update')"
        :sizeLg="role !== 2"
        :dialogOpen="showModalImportCompany"
        @toggleDialog="toggleImportCompany"
        @applyDialog="applyImportCompany"
        @downloadTemplate="downloadTemplateCompany"
        :header="$t('imports.import_companies_header')" 
        />
      <import-generic-dialog
        :secondaryTemplate="true"
        :activateSwitch1="true"
        :labelSwitch1="$t('imports.update_groups')" 
        :sizeLg="true"
        :dialogOpen="showModalImportGroup"
        @toggleDialog="toggleImportGroup"
        @applyDialog="applyImportGroup"
        @downloadTemplate="downloadTemplateGroup"
        :header="$t('imports.import_groups_header')" 
        />

    </template>
  </table-view>
</template>

<script>
import { i18n } from '@/i18n'
import TableView from '@/components/interfaces/TableView.vue'
import CustomFilter from '@/components/filters/ImportacionesFilter.vue'

/// Base
import { getImportsPag } from '@/services/configurations/imports/getImportsPag'
import { getImportsExcel } from '@/services/configurations/imports/getImportsExcel'

/// Acciones
import { cancelImport } from '@/services/configurations/imports/cancelImport'
import { downloadResultImport } from '@/services/configurations/imports/downloadResultImport'
import { downloadOriginImport } from '@/services/configurations/imports/downloadOriginImport'

/// Dialogos
// PFX
import ImportCertDialog from '@/components/ImportCertDialog.vue'
import { importCertificates } from '@/services/configurations/imports/importCertificates'

// Genericos
import ImportGenericDialog from '@/components/ImportGenericDialog.vue'

import { importProductos } from '@/services/configurations/imports/importProductos'
import { downloadTemplateProductos } from '@/services/configurations/imports/downloadTemplateProductos'

import { importSociedades } from '@/services/configurations/imports/importSociedades'
import { downloadTemplateSociedades } from '@/services/configurations/imports/downloadTemplateSociedades'

import { importCertsSerial } from '@/services/configurations/imports/importCertsSerial'
import { downloadTemplateCertsSerial } from '@/services/configurations/imports/downloadTemplateCertsSerial'

import { importGroups } from '@/services/configurations/imports/importGroups'
import { downloadTemplateGroups } from '@/services/configurations/imports/downloadTemplateGroups'
// import { downloadTemplateGroupsReparto } from '@/services/configurations/imports/downloadTemplateGroupsReparto'

import { importUsers } from '@/services/configurations/imports/importUsers'
import { downloadTemplateUsers } from '@/services/configurations/imports/downloadTemplateUsers'

import { importCompanies } from '@/services/configurations/imports/importCompanies'
import { downloadTemplateCompanies } from '@/services/configurations/imports/downloadTemplateCompanies'

export default {
  name: 'vista-importaciones',
  components: {
    TableView,
    ImportCertDialog,
    ImportGenericDialog,
  },
  data: function () {
    return {
      idVista: 94,
      FilterPanel: CustomFilter,
      vuexnamespace: 'imports',
      headerTitle: i18n.t('imports.header'),
      headerIcon: 'config',
      routeName: 'configurations/imports/details',
      excelName: `${i18n.t('imports.header').toLowerCase()}.xlsx`,
      PayloadSingleId: 'idImportacion',
      
      heightSelect: 0,
      heightInput: 35,
      
      listaAcciones: [
        { IdAccion: 100, Descripcion: i18n.t('imports.cancel'), icon: 'changestatus' },
        { IdAccion: 200, Descripcion: i18n.t('imports.download_result'), icon: 'download' },
        { IdAccion: 201, Descripcion: i18n.t('imports.download_origin'), icon: 'download' },
      ],
      
      isLoadedData: false,
      showModalImportCert: false,
      showModalImportGroup: false,
      showModalImportUser: false,
      showModalImportCertsSerial: false,
      showModalImportCompany: false,
      showModalImportProductos: false,
      showModalImportSociedades: false,

      loadingExcel: false,
      loadingDataTable: false,
      selected: [],
      listaAccionesFinal: [],
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    tiposImportacion () {
      return this.$store.getters['config/TIPOS_IMPORTACION']
    },
    tiposImportacionEstado () {
      return this.$store.getters['config/TIPOS_IMPORTACION_ESTADO']
    },
    footerAcciones () {
      return this.tiposImportacion
        .filter(x => x.id !== 5)
        .map(x => ({
          text: x.name, icon: x.icon, handler: () => this.showActionModal(x.id)
        }))
    },
  },
  watch: {
  },
  created: async function () {
  },
  mounted: async function () {
  },
  methods: {
    onSelectionChange: function (event) {
      let listaAccionesFinalAux = this.listaAcciones.slice()
      
      // Al seleccionar:
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        // Si no selecciona una única fila
        if (!event.dataItem) {
          event.dataItems = event.dataItems.map(x => ({ ...x, selected: true }))
        }
        const itemsSelected = event.dataItems.filter(d => d.selected === true)
        // Si es más de 1 solo cancelar. No permitimos descargas más de 1
        if (itemsSelected.length > 1) {
          listaAccionesFinalAux = listaAccionesFinalAux.filter(x => x.IdAccion === 100)
        } else {
          // Si no son todos Certificados no se puede descargar la entrada
          if (itemsSelected.length === itemsSelected.filter(x => x.idTipo === 1).length) {
            listaAccionesFinalAux = listaAccionesFinalAux.filter(x => x.IdAccion !== 201)
          }
          // Si hay alguno procesando, no se puede descargar el resultado
          if (itemsSelected.filter(x => x.idEstado === 0).length > 0) {
            listaAccionesFinalAux = listaAccionesFinalAux.filter(x => x.IdAccion !== 200)
          }
        } 
        // Si no son todos en Error no se puede cancelar
        if (itemsSelected.length !== itemsSelected.filter(x => x.idEstado === 2).length) {
          listaAccionesFinalAux = listaAccionesFinalAux.filter(x => x.IdAccion !== 100)
        }
      }
      this.listaAccionesFinal = listaAccionesFinalAux
    },
    getParamsPathAux (data) {
      return {
        id: data.idImportacion,
      }
    },
    getParamsAux (data) {
      return {
        fechaDesde: data.fechaDesde ? data.fechaDesde.value : null,
        fechaHasta: data.fechaHasta ? data.fechaHasta.value : null,
        tipoImportacion: data.tipoImportacion ? data.tipoImportacion.value : null,
        tipoImportacionEstado: data.tipoImportacionEstado ? data.tipoImportacionEstado.value : null,
        cliente: data.empresa ? data.empresa.value.Nombre : null,
        distribuidor: data.distribuidor ? data.distribuidor.value.Nombre : null,
        usuario: data.usuario ? data.usuario.value : null,
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getImportsPag(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      try {
        return await getImportsExcel(objOrder, params)
      } catch (error) {}
    },
    toggleImportProductos () {
      this.showModalImportProductos = !this.showModalImportProductos
    },
    applyImportProductos: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importProductos(file, { idCliente: form.idCliente })
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImportProductos() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          this.$refs.table.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleImportSociedades () {
      this.showModalImportSociedades = !this.showModalImportSociedades
    },
    applyImportSociedades: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importSociedades(file, { idCliente: form.idCliente })
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImportSociedades() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          this.$refs.table.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleImportCompany () {
      this.showModalImportCompany = !this.showModalImportCompany
    },
    applyImportCompany: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = { 
          idCliente: form.idCliente,
          actualizarCIFS: form.switch1,
        }
        const response = await importCompanies(file, params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImportCompany() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          this.$refs.table.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateCompany: async function (formIdCliente) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idCliente: formIdCliente
        }
        const response = await downloadTemplateCompanies(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-empresas.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleImportUser () {
      this.showModalImportUser = !this.showModalImportUser
    },
    toggleImportCertsSerial () {
      this.showModalImportCertsSerial = !this.showModalImportCertsSerial
    },
    applyImportUser: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importUsers(file, { idCliente: form.idCliente })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImportUser() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          this.$refs.table.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportCertsSerial: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importCertsSerial(file, { idCliente: form.idCliente })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImportCertsSerial() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          this.$refs.table.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateUser: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateUsers()
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-usuarios.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateCertsSerial: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateCertsSerial()
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-certificados-serial.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateProductos: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateProductos()
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-productos.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateSociedades: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateSociedades()
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-clientes-proveedores.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleImportGroup () {
      this.showModalImportGroup = !this.showModalImportGroup
    },
    applyImportGroup: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importGroups(file, { idCliente: form.idCliente, actualizarGrupos: form.switch1 })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImportGroup() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          this.$refs.table.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateGroup: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateGroups()
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-grupos-gestion.xlsx')
        }
        // const responseReparto = await downloadTemplateGroupsReparto()
        // if (responseReparto.blnError === true) {
        //   this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        // } else {
        //   this.downloadBlob(responseReparto, 'plantilla-importacion-grupos-reparto.xlsx')
        // }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleImportCert () {
      this.showModalImportCert = !this.showModalImportCert
    },
    applyImportCert: async function (files, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const certificados = []
        const listPromises = []
        // Ejemplo promesas multiples asincronas con espera final de todas
        files.forEach((file) => {
          listPromises.push(this.getBase64(file.raw)
            .then(res => {
              const b64 = res.split(',')[1]
              certificados.push({
                Base64: b64,
                Nombre: file.name
              })
            }))
        })
        await Promise.all(listPromises)
        const payload = {
          idCliente: form.idCliente,
          Password: form.value,
          VincularEmpresas: form.switch,
          Certificados: certificados,
        }
        const response = await importCertificates(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImportCert() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          this.$refs.table.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    executeAction: async function ({ action, selected = [], event }) {
      if (selected.length) {
        if (action.IdAccion === 100) { 
          this.cancelImport()
        } else if (action.IdAccion === 201) { 
          this.downloadExcelHandler(downloadOriginImport)
        } else if (action.IdAccion === 200) { 
          this.downloadExcelHandler(downloadResultImport)
        } else {
          console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
        }
      }
    },
    showActionModal: function (idAccion) {
      if (idAccion === 1) { 
        this.toggleImportCert()
      } else if (idAccion === 2) {
        this.toggleImportGroup()
      } else if (idAccion === 3) {
        this.toggleImportUser()
      } else if (idAccion === 4) {
        this.toggleImportCompany()
      } else if (idAccion === 5) {
        this.toggleImportCertsSerial() 
      } else if (idAccion === 6) {
        this.toggleImportProductos() 
      } else if (idAccion === 7) {
        this.toggleImportSociedades() 
      } 
    },
    cancelImport: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push(element)
        }
        const response = await cancelImport(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.$store.dispatch('app/getAnnouncementsList')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.$refs.table.applyFilters()
      }
    },
    downloadExcelHandler: async function (apiCall) {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await apiCall({ idImportacion: this.selected[0] })
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = response.headers.filename
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.log(error)
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
  }
}
</script>
